module.exports = __webpack_public_path__ + "img/tag.2991de37.png";